import { render } from "./twitterIntegration.vue?vue&type=template&id=36d9132d"
import script from "./twitterIntegration.vue?vue&type=script&lang=js"
export * from "./twitterIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__